
import { Flex, FlexProps } from '@chakra-ui/react';

type CardProps = FlexProps;

const Card = ({
    ...rest
}: CardProps) => {
  return (
    <Flex px={4} py={2} borderColor="gray.400" borderWidth={1} rounded="xl" shadow="md" {... rest} />
  )
}

export default Card